import { InformationPage } from "@/features/information/pages/Information";
import { InformationFilterCacheProvider } from "@/features/information/provider/InformationListFilterCacheProvider";

const Information = () => {
  return (
    <InformationFilterCacheProvider>
      <InformationPage />
    </InformationFilterCacheProvider>
  );
};

export default Information;
